import { render, staticRenderFns } from "./CampaignMessagesTable.vue?vue&type=template&id=192f5b84&"
import script from "./CampaignMessagesTable.vue?vue&type=script&lang=js&"
export * from "./CampaignMessagesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports